// **  Initial State
const initialState = []

const adminsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_ADMINS':
            return action.payload
        default:
            return state
    }
}

export default adminsReducer
